import type { ComponentSingleStyleConfig } from '@chakra-ui/theme';
import { BorderWidths, Colors, Space, TextStyles } from '../../types';

export const Table: ComponentSingleStyleConfig = {
  baseStyle: {
    table: {
      background: Colors.SURFACE_PAGE,
      color: Colors.TEXT_EMPHASIS,
      borderColor: Colors.BORDER_DEFAULT,
      apply: `textStyles.${TextStyles.P2}`,
      thead: {
        bg: Colors.SURFACE_INSET,
      },
    },
    thead: {
      th: {
        textTransform: 'none',
        letterSpacing: 'normal',
        fontWeight: 'semibold',
        color: Colors.TEXT_MUTED,
        borderColor: Colors.BORDER_DEFAULT,
        borderBottomWidth: BorderWidths.XS,
      },
    },
    tbody: {
      td: {
        borderColor: Colors.BORDER_SUBDUED,
        borderBottomWidth: BorderWidths.XS,
      },
      tr: {
        _last: {
          td: {
            borderColor: 'transparent',
          },
        },
      },
    },

    tfoot: {
      borderTopWidth: BorderWidths.XS,
      borderColor: Colors.BORDER_DEFAULT,
      borderBottomWidth: '0px',
      textAlign: 'center',
      bg: Colors.SURFACE_INSET,
      td: {
        py: Space.XS,
        borderBottomWidth: '0px',
      },
    },
    caption: {
      fontWeight: 'normal',
      m: '0',
    },
  },
  sizes: {
    sm: {
      th: {
        p: '2.5',
      },
      td: {
        p: '2.5',
      },
      caption: {
        p: '2.5',
      },
    },
    md: {
      th: {
        px: '3',
        py: '2',
      },
      td: {
        p: '3',
      },
      caption: {
        px: '3',
        py: '2',
      },
    },
    lg: {
      th: {
        px: '4',
        py: '3',
      },
      td: {
        p: '4',
      },
      caption: {
        px: '4',
        py: '3',
      },
    },
  },
  variants: {
    simple: {
      th: {
        // Foundry CSS removes all table borders and trumps Chakra, so increase specificity
        '&': {
          color: Colors.TEXT_MUTED,
          borderColor: Colors.BORDER_DEFAULT,
        },
      },
      td: {
        '&': {
          borderColor: Colors.BORDER_SUBDUED,
          borderBottom: '1px solid',
        },
      },
    },
    striped: {
      tbody: {
        tr: {
          td: {
            borderColor: 'transparent',
          },
          '&:nth-of-type(odd)': {
            'th, td': {
              borderColor: 'transparent',
            },
            td: {
              background: Colors.SURFACE_INSET,
            },
          },
        },
      },
    },
  },
  defaultProps: {
    colorScheme: 'gray',
    variant: 'simple',
  },
};
